// extracted by mini-css-extract-plugin
export default {"font":"Font_font__X-Qvy"};